<template>
	<div class="sitesetting">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys" ></menuBar>
			<a-layout style="overflow: auto;">
				<topBar></topBar>
				<a-layout-content style="margin: 16px 32px 16px 16px; min-width: 1192px;">
					<div style="font-size: 20px;line-height: 30px;margin-bottom: 10px;font-weight: 700;">站点设置</div>
					<div class="contentcard">
						<div>
							<span>站点名称</span>
							<a-input placeholder="站点名称" style="width: 300px;"></a-input>
						</div>
						<div style="margin-top: 20px;">
							<span>站点地址</span>
							<a-input placeholder="站点地址" style="width: 300px;"></a-input>
						</div>
						<div>该页面功能暂未开发完成</div>
					</div>
				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>
	</div>
</template>

<script>

	export default {

		data() {
			return {
				current: ['sitesetting'],
				openKeys: [''],
			}
		},
		created: function() {
			var self = this;
			this.$axios.get('/basic/sitesetting').then(function(res) {
				console.log(res.data);
			});
		},
		methods: {
		},

	};
</script>

<style>

	.sitesetting .contentcard {
		padding: 24px 50px;
		background-color: #fff;
		min-height: 300px;
		border-radius: 5px;
		margin-bottom: 20px;
	}
</style>



// WEBPACK FOOTER //
// index.vue?0764b2e7